__turbopack_context__.v({
  "actions": "WCard-module__b2mIZG__actions",
  "badge": "WCard-module__b2mIZG__badge",
  "badgeZero": "WCard-module__b2mIZG__badgeZero",
  "body": "WCard-module__b2mIZG__body",
  "bottom": "WCard-module__b2mIZG__bottom",
  "closeBtn": "WCard-module__b2mIZG__closeBtn",
  "continueBtn": "WCard-module__b2mIZG__continueBtn",
  "count": "WCard-module__b2mIZG__count",
  "countBtn": "WCard-module__b2mIZG__countBtn",
  "countInput": "WCard-module__b2mIZG__countInput",
  "deleteBtn": "WCard-module__b2mIZG__deleteBtn",
  "details": "WCard-module__b2mIZG__details",
  "drawer": "WCard-module__b2mIZG__drawer",
  "empty": "WCard-module__b2mIZG__empty",
  "footer": "WCard-module__b2mIZG__footer",
  "header": "WCard-module__b2mIZG__header",
  "item": "WCard-module__b2mIZG__item",
  "itemBusy": "WCard-module__b2mIZG__itemBusy",
  "linePrice": "WCard-module__b2mIZG__linePrice",
  "linePriceBefore": "WCard-module__b2mIZG__linePriceBefore",
  "list": "WCard-module__b2mIZG__list",
  "name": "WCard-module__b2mIZG__name",
  "overlay": "WCard-module__b2mIZG__overlay",
  "payBtn": "WCard-module__b2mIZG__payBtn",
  "root": "WCard-module__b2mIZG__root",
  "slideIn": "WCard-module__b2mIZG__slideIn",
  "thumb": "WCard-module__b2mIZG__thumb",
  "thumbPlaceholder": "WCard-module__b2mIZG__thumbPlaceholder",
  "title": "WCard-module__b2mIZG__title",
  "totalLabel": "WCard-module__b2mIZG__totalLabel",
  "totalRow": "WCard-module__b2mIZG__totalRow",
  "totalValue": "WCard-module__b2mIZG__totalValue",
  "trigger": "WCard-module__b2mIZG__trigger",
  "triggerIcon": "WCard-module__b2mIZG__triggerIcon",
  "variantRow": "WCard-module__b2mIZG__variantRow",
  "variantSwatch": "WCard-module__b2mIZG__variantSwatch",
  "variantSwatchImg": "WCard-module__b2mIZG__variantSwatchImg",
  "variantValueName": "WCard-module__b2mIZG__variantValueName",
  "variants": "WCard-module__b2mIZG__variants",
});
